<script setup>
import {RMLoader} from 'redmine-ui-kit';
import {useI18n} from 'vue-i18n';

import ReportsView from '@/views/ReportsView.vue';
import ModalsView from '@/views/ModalsView.vue';
import {useStore} from '@/core/plugins/store';

const {locale} = useI18n({useScope: 'global'});
const {store} = useStore();

const lang = store.value.userData?.language;

if (lang) {
    locale.value = lang;
}
</script>

<template>
    <div class="rm-app">
        <ReportsView />
        <ModalsView />
        <RMLoader :is-active="$store.isRequestPending" />
    </div>
</template>
